export default {
  name: '{locale}',
  attributes: {
    name: 'nombre',
    client: 'cliente',
    payment_method: 'metodo de pago',
    payment_term: 'plazo credito',
    payment_form: 'medio de pago',
    currency: 'moneda',
    note: 'nota',

    //Create document row
    name_0: 'nombre artículo',
    price_0: 'precio',

    //Email
    subject: 'asunto',
    body: 'contenido',

    identification: 'número identificación',
    identification_type: 'tipo identificación',
    phone: 'telefono',
    other_signs: 'otras señas',

    message_detail: 'detalle mensaje',
    condition: 'condición',
    category: 'categoría'
  }
};